function dateFormat(second) {
  if (!second) {
    return false
  }

  const day = fill_zero_prefix(Math.floor(second / (24 * 3600)))
  const hr = fill_zero_prefix(Math.floor((second - day * 24 * 3600) / 3600))
  const min = fill_zero_prefix(Math.floor((second - day * 24 * 3600 - hr * 3600) / 60))
  const sec = fill_zero_prefix(second - day * 24 * 3600 - hr * 3600 - min * 60)

  return {
    day,
    hr,
    min,
    sec
  }
}

function fill_zero_prefix(num) {
  return num < 10 ? '0' + num : num
}

export default dateFormat
